module.exports = "<div class=\"content content-deprecated\">\n    <h1 class=\"screen-title-light\">Reports</h1>\n    <div >\n        <span ><img alt=\"\" ng-src=\"../images/construction/construction01.jpg\" /></span>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/controllers/mastercard/taxSales.html
// module id = 356
// module chunks = 0